import React, { useEffect, useState } from 'react';
import hash from "object-hash";
import LiveResponsiveGrid from './LiveGrid';
import { QueueCallState } from '../QueueLeaderboard';
import { MetricObject } from '../QueueWidgetContainer';



function LiveDashboard({  
  mode, 
  accessToken,
  ivrStates,
  historicalUsers, 
  historicalQueues,
  leaderboardDeltas,
  queueCallStates,
  liveQueueMetrics,
  orgId,
  tabCounts
}: { 
  accessToken: string;
  tabCounts: {abandoned: number, callback: number, voicemail: number},
  mode: string; 
  ivrStates: any;
  historicalUsers: any;
  historicalQueues: any
  leaderboardDeltas: any;
  queueCallStates: QueueCallState[]
  liveQueueMetrics: Map<string, MetricObject>
  orgId: string | undefined
  // ivrDeltas: any
}) {

  const [historicalUserList, setHistoricalUserList] = useState<any>()
  const [historicalQueueList, setHistoricalQueueList] = useState<any>()
  const [previousDeltas, setPreviousDeltas] = useState<any>({})
  const [userDeltas, setUserDeltas] = useState<Map<string, any>>(new Map());
  const [queueDeltas, setQueueDeltas] = useState<Map<string, any>>(new Map());
  const [quickDeltas, setQuickDeltas] = useState<Map<string, any>>(new Map());


  
useEffect(() => {
  if (!leaderboardDeltas) return;
  if (hash(previousDeltas) === hash(leaderboardDeltas)) return;

  const calculateAverage = (total: number, count: number): number => count > 0 ? total / count : 0;
  const newUserDeltas = new Map(userDeltas);
  const newQueueDeltas = new Map(queueDeltas);
  const newQuickDeltas = new Map(quickDeltas);

  leaderboardDeltas.forEach((newDelta: any) => {
    const { userId } = newDelta;
    if (!userId) return;  
    // if user
    if (historicalUsers.find((historical: any) => historical.id === userId )) {
      const oldDelta = newUserDeltas.get(userId);
      const oldCallResults = newQuickDeltas.get("callResults")

      if (!oldDelta) {
        newUserDeltas.set(userId, { ...newDelta });
        return;
      }
      const mergedDelta = { ...oldDelta };
      mergedDelta.count = (oldDelta.count ?? 0) + (newDelta.count ?? 0);
      mergedDelta.duration = (oldDelta.duration ?? 0) + (newDelta.duration ?? 0);
      mergedDelta.hangupCount = (oldDelta.hangupCount ?? 0) + (newDelta.hangupCount ?? 0);
      mergedDelta.maxDuration = (oldDelta.maxDuration ?? 0) + (newDelta.maxDuration ?? 0);
      mergedDelta.maxRingTimeInbound = (oldDelta.maxRingTimeInbound ?? 0) + (newDelta.maxRingTimeInbound ?? 0);
      mergedDelta.maxRingTimeInternal = (oldDelta.maxRingTimeInternal ?? 0) + (newDelta.maxRingTimeInternal ?? 0);
      mergedDelta.maxTalkTimeInbound = (oldDelta.maxTalkTimeInbound ?? 0) + (newDelta.maxTalkTimeInbound ?? 0);
      mergedDelta.maxTalkTimeInternal = (oldDelta.maxTalkTimeInternal ?? 0) + (newDelta.maxTalkTimeInternal ?? 0);
      mergedDelta.missedCount = (oldDelta.missedCount ?? 0) + (newDelta.missedCount ?? 0);
      mergedDelta.missedTime = (oldDelta.missedTime ?? 0) + (newDelta.missedTime ?? 0);
      mergedDelta.ringCountInbound = (oldDelta.ringCountInbound ?? 0) + (newDelta.ringCountInbound ?? 0);
      mergedDelta.ringCountInternal = (oldDelta.ringCountInternal ?? 0) + (newDelta.ringCountInternal ?? 0);
      mergedDelta.ringTimeInbound = (oldDelta.ringTimeInbound ?? 0) + (newDelta.ringTimeInbound ?? 0);
      mergedDelta.ringTimeInternal = (oldDelta.ringTimeInternal ?? 0) + (newDelta.ringTimeInternal ?? 0)
      mergedDelta.talkCountInbound = (oldDelta.talkCountInbound ?? 0) + (newDelta.talkCountInbound ?? 0);
      mergedDelta.talkCountInternal = (oldDelta.talkCountInternal ?? 0) + (newDelta.talkCountInternal ?? 0);
      mergedDelta.talkTimeInbound = (oldDelta.talkTimeInbound ?? 0) + (newDelta.talkTimeInbound ?? 0);
      mergedDelta.talkTimeInternal = (oldDelta.talkTimeInternal ?? 0) + (newDelta.talkTimeInternal ?? 0);
      mergedDelta.vmCount = (oldDelta.vmCount ?? 0) + (newDelta.vmCount ?? 0);
      mergedDelta.vmDurationTime = (oldDelta.vmDurationTime ?? 0) + (newDelta.vmDurationTime ?? 0);
      mergedDelta.vmGreetingTime = (oldDelta.vmGreetingTime ?? 0) + (newDelta.vmGreetingTime ?? 0);
      mergedDelta.vmLeftCount = (oldDelta.vmLeftCount ?? 0) + (newDelta.vmLeftCount ?? 0);
      mergedDelta.holdTimeInbound = (oldDelta.holdTimeInbound ?? 0) + (newDelta.holdTimeInbound ?? 0);
      mergedDelta.holdCountInbound = (oldDelta.holdCountInbound ?? 0) + (newDelta.holdCountInbound ?? 0);
      mergedDelta.holdTimeOutbound = (oldDelta.holdTimeOutbound ?? 0) + (newDelta.holdTimeOutbound ?? 0);
      mergedDelta.holdCountOutbound = (oldDelta.holdCountOutbound ?? 0) + (newDelta.holdCountOutbound ?? 0);
      mergedDelta.durationAvg = calculateAverage(mergedDelta.duration, mergedDelta.count);
      mergedDelta.ringTimeAvgInbound = calculateAverage(mergedDelta.ringTimeInbound, mergedDelta.ringCountInbound);
      mergedDelta.ringTimeAvgOutbound = calculateAverage(mergedDelta.ringTimeOutbound, mergedDelta.ringCountOutbound);
      mergedDelta.talkTimeAvgInbound = calculateAverage(mergedDelta.talkTimeInbound, mergedDelta.talkCountInbound);
      mergedDelta.talkTimeAvgOutbound = calculateAverage(mergedDelta.talkTimeOutbound, mergedDelta.talkCountOutbound);
      mergedDelta.holdTimeAvgInbound = calculateAverage(mergedDelta.holdTimeInbound ?? 0, mergedDelta.holdCountInbound ?? 1);
      mergedDelta.holdTimeAvgOutbound = calculateAverage(mergedDelta.holdTimeOutbound ?? 0, mergedDelta.holdCountOutbound ?? 1);
      
      newUserDeltas.set(userId, mergedDelta);
    }
  // if queue
    if (historicalQueues.find((historical: any) => historical.id === userId )) {
        const oldDelta = newQueueDeltas.get(userId);
        if (!oldDelta) {
          newQueueDeltas.set(userId, { ...newDelta });
          return;
        }
        const mergedDelta = { ...oldDelta };
        mergedDelta.count = (oldDelta.count ?? 0) + (newDelta.count ?? 0);
        mergedDelta.duration = (oldDelta.duration ?? 0) + (newDelta.duration ?? 0);
        mergedDelta.hangupCount = (oldDelta.hangupCount ?? 0) + (newDelta.hangupCount ?? 0);
        mergedDelta.maxDuration = (oldDelta.maxDuration ?? 0) + (newDelta.maxDuration ?? 0);
        mergedDelta.maxRingTimeInbound = (oldDelta.maxRingTimeInbound ?? 0) + (newDelta.maxRingTimeInbound ?? 0);
        mergedDelta.maxRingTimeInternal = (oldDelta.maxRingTimeInternal ?? 0) + (newDelta.maxRingTimeInternal ?? 0);
        mergedDelta.maxTalkTimeInbound = (oldDelta.maxTalkTimeInbound ?? 0) + (newDelta.maxTalkTimeInbound ?? 0);
        mergedDelta.maxTalkTimeInternal = (oldDelta.maxTalkTimeInternal ?? 0) + (newDelta.maxTalkTimeInternal ?? 0);
        mergedDelta.missedCount = (oldDelta.missedCount ?? 0) + (newDelta.missedCount ?? 0);
        mergedDelta.missedTime = (oldDelta.missedTime ?? 0) + (newDelta.missedTime ?? 0);
        mergedDelta.ringCountInbound = (oldDelta.ringCountInbound ?? 0) + (newDelta.ringCountInbound ?? 0);
        mergedDelta.ringCountInternal = (oldDelta.ringCountInternal ?? 0) + (newDelta.ringCountInternal ?? 0);
        mergedDelta.ringTimeInbound = (oldDelta.ringTimeInbound ?? 0) + (newDelta.ringTimeInbound ?? 0);
        mergedDelta.ringTimeInternal = (oldDelta.ringTimeInternal ?? 0) + (newDelta.ringTimeInternal ?? 0)
        mergedDelta.talkCountInbound = (oldDelta.talkCountInbound ?? 0) + (newDelta.talkCountInbound ?? 0);
        mergedDelta.talkCountInternal = (oldDelta.talkCountInternal ?? 0) + (newDelta.talkCountInternal ?? 0);
        mergedDelta.talkTimeInbound = (oldDelta.talkTimeInbound ?? 0) + (newDelta.talkTimeInbound ?? 0);
        mergedDelta.talkTimeInternal = (oldDelta.talkTimeInternal ?? 0) + (newDelta.talkTimeInternal ?? 0);
        mergedDelta.vmCount = (oldDelta.vmCount ?? 0) + (newDelta.vmCount ?? 0);
        mergedDelta.vmDurationTime = (oldDelta.vmDurationTime ?? 0) + (newDelta.vmDurationTime ?? 0);
        mergedDelta.vmGreetingTime = (oldDelta.vmGreetingTime ?? 0) + (newDelta.vmGreetingTime ?? 0);
        mergedDelta.vmLeftCount = (oldDelta.vmLeftCount ?? 0) + (newDelta.vmLeftCount ?? 0);
        mergedDelta.holdTimeInbound = (oldDelta.holdTimeInbound ?? 0) + (newDelta.holdTimeInbound ?? 0);
        mergedDelta.holdCountInbound = (oldDelta.holdCountInbound ?? 0) + (newDelta.holdCountInbound ?? 0);
        mergedDelta.holdTimeOutbound = (oldDelta.holdTimeOutbound ?? 0) + (newDelta.holdTimeOutbound ?? 0);
        mergedDelta.holdCountOutbound = (oldDelta.holdCountOutbound ?? 0) + (newDelta.holdCountOutbound ?? 0);
        mergedDelta.durationAvg = calculateAverage(mergedDelta.duration, mergedDelta.count);
        mergedDelta.ringTimeAvgInbound = calculateAverage(mergedDelta.ringTimeInbound, mergedDelta.ringCountInbound);
        mergedDelta.ringTimeAvgOutbound = calculateAverage(mergedDelta.ringTimeOutbound, mergedDelta.ringCountOutbound);
        mergedDelta.talkTimeAvgInbound = calculateAverage(mergedDelta.talkTimeInbound, mergedDelta.talkCountInbound);
        mergedDelta.talkTimeAvgOutbound = calculateAverage(mergedDelta.talkTimeOutbound, mergedDelta.talkCountOutbound);
        mergedDelta.holdTimeAvgInbound = calculateAverage(mergedDelta.holdTimeInbound ?? 0, mergedDelta.holdCountInbound ?? 1);
        mergedDelta.holdTimeAvgOutbound = calculateAverage(mergedDelta.holdTimeOutbound ?? 0, mergedDelta.holdCountOutbound ?? 1);
        
        newQueueDeltas.set(userId, mergedDelta);
        }
    
  });

  setPreviousDeltas(leaderboardDeltas);

  setUserDeltas(newUserDeltas);
  setQueueDeltas(newQueueDeltas);

}, [leaderboardDeltas]);


    //  GET user list 
    useEffect(() => {
      if (
        historicalQueues &&
        historicalUsers
      ) {
        setHistoricalUserList(Array.from(historicalUsers.values()).map((user: any) => ({
          name: `${user.firstName} ${user.lastName}`,
          department: user.department,
          extensionNumber: user.extensionNumber, 
          id: user.id,
          uri: user.uri,
          handRaised: user.emergency
      })))
      setHistoricalQueueList(Array.from(historicalQueues.values()).map((queue: any) => ({
        ...queue,
        name: queue.name,
        extensionNumber: queue.extensionNumber
      })))
      }
    }, [historicalUsers, historicalQueues])


  return (
    <div style={{ position: 'relative' }}>
      <LiveResponsiveGrid 
      accessToken={accessToken}
      historicalUserList={historicalUserList}
      historicalQueueList={historicalQueueList}
      lightMode={mode === 'light'}
      userDeltas={userDeltas}
      orgId={orgId}
      queueDeltas={queueDeltas}
      queueCallStates={queueCallStates}
      liveQueueMetrics={liveQueueMetrics}
      tabCounts={tabCounts}
      />
    </div>
  );
}

export default LiveDashboard;
